import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-freshpressedjuice',
  templateUrl: './icon-freshpressedjuice.component.html',
  styleUrls: ['./icon-freshpressedjuice.component.scss']
})
export class IconFreshpressedjuiceComponent implements OnInit {

  @Input() cssClass = 'icon--18';
  
  constructor() { }

  ngOnInit() {
  }

}
